<template>
  <div class="padding-10">
    <Header v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher" />
    <Table />
  </div>
</template>

<script>
import Header from "../components/carmake/Toolbar";
import Table from "../components/carmake/Table.vue";
export default {
  components: {
    Header,
    Table,
  },
};
</script>

<style></style>
